import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {environment} from "../../environments/environment";
import {menuItemsSidebarBo} from "../const/menu-items-sidebar-bo";
import {SidebarHelper} from "../helpers/sidebar.helper";
import {ProductsHelper} from "../helpers/products.helper";
import {ROUTES_PATHS} from "../const/routes";
import {denyAccessToMyInformation} from "../const/utils";

@Component({
	selector: 'app-sidebar-bo',
	templateUrl: './sidebar-bo.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./sidebar-bo.component.less']
})
export class SidebarBoComponent implements OnInit, OnDestroy {
	options: any;
	globalTxt: any = null;
	modalsTxt: any = null;
	isSidebarVisible: boolean = false;
	menuSidebar: any[] = [];
	userRole: any = localStorage.getItem('user_role');
	textInfoSubscription: string = '';
	subId: string = '';
	isAlreadyCancelled: boolean = false;
	subscriptionEndDate: string = '';
	subscriptionProductName: string = '';

	constructor(
		public app: AppComponent,
		public sidebarHelper: SidebarHelper,
		public productsHelper: ProductsHelper
	) {
		this.isSidebarVisible = this.sidebarHelper.isSidebarVisible;
	}

	toggleSidebar() {
		this.isSidebarVisible = !this.isSidebarVisible;
		this.sidebarHelper.getAllContentStatic(this.isSidebarVisible);
	}

	ngOnDestroy() {
		this.sidebarHelper.destroySidebar();
	}

	ngOnInit(): void {
		this.sidebarHelper.initializeSidebar();
		this.sidebarHelper.resizeSubscriptionSetup();

		this.getInfosInit();
	}

	getNavItemActive(_item: any) {
		let page = location.pathname.split('/')[1];
		return page === _item.path;
	}

	getNavItemRoleAdmin(_item: any) {
		let user_role_nb = parseInt(this.userRole, 10);
		return _item.roles.includes(user_role_nb) && _item.roles.length === 1;
	}

	getInfosInit() {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;
			this.textInfoSubscription = globalTxt.sidebarBo.textInfoSubscription;

			// Get the modal texts
			this.app.dataInitService.getModalTextsOnce(modalsTxt => {
				this.modalsTxt = modalsTxt;
			});

			// Get menu items for the sidebar
			const refKey = this.app.sharedToolsService.returnObjectSwitchRefId();

			this.menuSidebar = menuItemsSidebarBo.filter((item: any) => {
				let user_role_nb = parseInt(this.userRole, 10);
				return (item.roles.length === 0 || item.roles.includes(user_role_nb))
						&& item.environment?.includes(environment.name)
						&& (
							item.path !== ROUTES_PATHS.MON_COMPTE
							|| !denyAccessToMyInformation.includes(refKey)
						);
			});

			this.getFirstSubscription();
		});
	}

	getFirstSubscription() {
		this.app.apiToolsService.getFirstSubscription().subscribe({
			next: (res: any) => {
				console.log("getFirstSubscription → ", res);
				this.subId = res?.SubscriptionId || '';
				this.isAlreadyCancelled = res?.IsCancelled || false;
				// Get the product name
				let productName: string = res?.ProductName || '';
				this.subscriptionProductName = this.productsHelper.getProductTexts(productName, 'label');
				// Format the end date
				let subscriptionEndDate = new Date(res?.CurrentPeriodEnd || '');
				this.subscriptionEndDate = subscriptionEndDate.toLocaleDateString('fr-FR', {
					day: '2-digit',
					month: '2-digit',
					year: 'numeric'
				});

				// Update the subscription info text
				this.textInfoSubscription = this.textInfoSubscription.replace('[PRODUCT_NAME]', this.subscriptionProductName).replace('[DATE_END]', this.subscriptionEndDate);
			},
			error: (err) => {
				if (err.status === 404 && err.error === "Customer not found !") {
					console.log("Aucune souscription trouvée pour cet utilisateur.");
					this.subId = '';
				} else {
					console.error("Erreur lors de getFirstSubscription → ", err);
				}
			}
		});
	}

	cancelSubscription() {
		this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalUnsubscribeAccount, "confirm", "", () => {
			console.log("Annuler l'abonnement");
			this.app.apiToolsService.cancelSubscriptionById(this.subId)
				.subscribe((res: any) => {
					console.log("cancelSubscriptionById ==> ", res);
					this.app.confirmDialogService.confirmThis(
						'',
						this.modalsTxt.modalUnsubscribeAccountSuccess,
						"alert",
						"",
						() => {
							console.log("Abonnement annulé avec succès.");
							// Reload page
							window.location.reload();
						}, () => {
						});
				});
		}, () => {
			console.log("Ne pas annuler l'abonnement");
		});
	}
}
